import { ElementRef } from '@angular/core';

export interface DragScrollConfig {
  element: HTMLElement;
  isDown: boolean;
  startX: number;
  scrollLeft: number;
  mouseDownHandler?: (e: MouseEvent) => void;
  mouseLeaveHandler?: () => void;
  mouseUpHandler?: () => void;
  mouseMoveHandler?: (e: MouseEvent) => void;
}

export class TableUtils {
  private static activeConfigs: DragScrollConfig[] = [];

  static createDragScrollConfig(
    elementRef: ElementRef
  ): DragScrollConfig {
    return {
      element: elementRef.nativeElement,
      isDown: false,
      startX: 0,
      scrollLeft: 0
    };
  }

  static initializeDragScrolling(
    config: DragScrollConfig
  ): void {
    const slider = config.element;

    config.mouseDownHandler = (e: MouseEvent) => {
      config.isDown = true;

      slider.classList.add('dragging');

      config.startX = e.pageX - slider.offsetLeft;
      config.scrollLeft = slider.scrollLeft;
    };

    config.mouseLeaveHandler = () => {
      config.isDown = false;

      slider.classList.remove('dragging');
    };

    config.mouseUpHandler = () => {
      config.isDown = false;

      slider.classList.remove('dragging');
    };

    config.mouseMoveHandler = (e: MouseEvent) => {
      if (!config.isDown) return;

      e.preventDefault();

      const x = e.pageX - slider.offsetLeft;

      const walk = (x - config.startX) * 1.5;

      slider.scrollLeft = config.scrollLeft - walk;
    };

    slider.addEventListener(
      'mousedown',
      config.mouseDownHandler
    );

    slider.addEventListener(
      'mouseleave',
      config.mouseLeaveHandler
    );

    slider.addEventListener(
      'mouseup',
      config.mouseUpHandler
    );

    slider.addEventListener(
      'mousemove',
      config.mouseMoveHandler
    );

    this.activeConfigs.push(config);
  }

  static cleanup(element?: HTMLElement): void {

    if (!element) {
      return;
    }
  
    element.onmousedown = null;
    element.onmousemove = null;
    element.onmouseup = null;
    element.onmouseleave = null;
  
    element.style.cursor = '';
    element.style.userSelect = '';
  }
}